import { render, staticRenderFns } from "./SystemNotifications.vue?vue&type=template&id=23fd330e&scoped=true&"
import script from "./SystemNotifications.vue?vue&type=script&lang=js&"
export * from "./SystemNotifications.vue?vue&type=script&lang=js&"
import style0 from "./SystemNotifications.vue?vue&type=style&index=0&id=23fd330e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fd330e",
  null
  
)

export default component.exports